export default "__VITE_ASSET__BbG5TyPp__"